import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ReportTemplatesLazy = React.lazy(
	() => import(/* webpackChunkName : 'ReportTemplatesLazy' */ './components')
);

export default (store) => {
	return {
		path: 'report-templates/:campusId?',
		element: <AsyncLoading component={<ReportTemplatesLazy />} />,
		children: [],
	};
};
